import { Box, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box
      sx={{
        background: "#1E3A8A",
        color: "#fff",
        textAlign: "center",
        py: 4,
      }}
    >
      <Typography>
        © 2026 VedicWin Tuition Center
      </Typography>

      <Typography>
        Building Bright Futures
      </Typography>
    </Box>
  );
}